export const VITO = {
  id: 6,
  slugRo: '/rent-a-car/inchiriere-minivan-brasov',
  slugEn: '/en/rent-a-car/minivan-rental-brasov',
  name: 'Mercedes-Benz Vito Tourer',
  shortName: 'Mercedes Vito',
  year: 2018,
  seats: '7+1',
  luggage: 7,
  transmission: { ro: 'Automată', en: 'Automatic' },
  fuel: { ro: 'Motorină', en: 'Diesel' },
  pricePerDay: 80,
  currency: 'EUR',
  deposit: 600,
  scdwPerDay: 20,
  licence: 'B',
  minAge: 21,
  licenceYears: 2,
  unlimitedKm: true,
  freeDelivery: true,
  crossBorderFee: 100,
  winterTyres: true,
  childSeatsFree: true,
  withDriver: true,
  images: [
    {
      src: '/images/vito.webp',
      altRo: 'Mercedes-Benz Vito Tourer 7+1 locuri de închiriat în Brașov – vedere exterioară',
      altEn: 'Mercedes-Benz Vito Tourer 7+1 seats for rent in Brașov – exterior view',
    },
  ],
  card: {
    name: 'Mercedes Vito',
    pricePerDay: 80,
    passengers: '7+1',
    luggage: 7,
    transmission: 'Automatic',
    fuel: 'Diesel',
    image: '/images/vito.webp',
  },
};

export const fleet = [VITO];

export const vitoFaq = [
  {
    qRo: 'Pot conduce Mercedes Vito cu permis categoria B?',
    qEn: 'Can I drive the Mercedes Vito with a category B licence?',
    aRo: 'Da. Mercedes-Benz Vito Tourer cu 7+1 locuri se conduce cu permis categoria B. Șoferul trebuie să aibă minimum 21 de ani și permisul obținut de cel puțin 2 ani.',
    aEn: 'Yes. The 7+1 seat Mercedes-Benz Vito Tourer can be driven with a category B licence. The driver must be at least 21 years old and have held the licence for at least 2 years.',
  },
  {
    qRo: 'Câte valize încap cu toate locurile ocupate?',
    qEn: 'How many suitcases fit with all seats in use?',
    aRo: 'Încap 7 valize mari, chiar și cu toate cele 7+1 locuri ocupate.',
    aEn: '7 large suitcases fit, even with all 7+1 seats in use.',
  },
  {
    qRo: 'Există garanție?',
    qEn: 'Is there a deposit?',
    aRo: 'Garanția standard este de 600 €. Poți alege opțiunea SCDW cu garanție zero, pentru 20 € pe zi.',
    aEn: 'The standard deposit is €600. You can choose the SCDW zero-deposit option for €20 per day.',
  },
  {
    qRo: 'Este echipat pentru iarnă?',
    qEn: 'Is it equipped for winter?',
    aRo: 'Da. Anvelopele de iarnă sunt incluse în preț.',
    aEn: 'Yes. Winter tyres are included in the price.',
  },
  {
    qRo: 'Pot ieși cu el din țară?',
    qEn: 'Can I take it abroad?',
    aRo: 'Da, cu aprobare prealabilă din partea noastră și o taxă de 100 €.',
    aEn: 'Yes, with our prior approval and a €100 fee.',
  },
  {
    qRo: 'Pot închiria Vito cu șofer?',
    qEn: 'Can I rent it with a driver?',
    aRo: 'Da. Îl oferim și cu șofer, sub formă de transfer – vezi pagina de transferuri.',
    aEn: 'Yes. We also offer it with a driver, as a transfer – see the transfers page.',
  },
];

export const routeAlternates = {
  [VITO.slugRo]: VITO.slugEn,
  [VITO.slugEn]: VITO.slugRo,
};
